import { Injectable } from '@angular/core';
import { UserDataService } from './user-data.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { WriteService } from './writes.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  all: any[];
  // all:  Observable<any[]>;

  constructor(
    private usd: UserDataService,
    private ws: WriteService,
    private ns: NotificationService
  ) {
    this.getAllUsers();
  }

  getAllUsers() {
    // this.usd.afs.collection(`Users`, ref => ref.where())
    // this.usd.afs.collection(`Users`).valueChanges().subscribe(all => {

    // })
    // this.all = this.usd.afs.collection<any>(`Users`).valueChanges();
    // return this.all;
    this.usd.afs.collection<any>(`Users`).valueChanges().subscribe((all) => {
      // console.log(all);
      // this.all = all.filter(gs => gs?.guest && gs?.guest === true);
      this.all = all;
    });
  }

  recallAll() {
    console.log(this.all.length);
    this.all.filter((user: any) => {
      user.recallBy = this.usd.acc;
      if (!user.lastSignInTime) {
        this.sendRecallEmail(user);
      } else if (
        !user.sysRecallTime &&
        user.lastSignInTime &&
        moment(user.lastSignInTime).isAfter(moment().subtract(1, 'months'))
      ) {
        this.sendRecallEmail(user);
      } else if (
        user.lastSignInTime &&
        moment(user.lastSignInTime).isAfter(moment().subtract(1, 'months')) &&
        user.sysRecallTime &&
        moment(user.sysRecallTime).isAfter(moment().subtract(1, 'months'))
      ) {
        this.sendRecallEmail(user);
      } else {
        // this.sendRecallEmail(user);
      }
    });
  }

  recallUser(user) {
    console.log(user);
    user.recallBy = this.usd.acc;
    const userPath = this.usd.afs.doc(`Users/${user?.id}`);
    userPath.ref.get().then((refDs) => {
      if (refDs.exists) {
        const userData = refDs.data();
        user.providerId = userData.providerId || null;
        this.sendRecallEmail(user);
      }
    });

    this.sendRecallEmail(user);
    userPath
      .update({ sysRecallTime: moment().toISOString() })
      .then(() => {
        console.log(`recall ${user.name} done`);
        this.ns.showNotification('recall', 'top', 'right', user);
      })
      .catch((er) => console.log(er));
  }

  async sendRecallEmail(ds) {
    const userPath = this.usd.afs.doc(`Users/${ds?.id}`);
    userPath
      .update({ sysRecallTime: moment().toISOString() })
      .then(() => console.log(`recall ${ds.name} done`))
      .catch((er) => console.log(er));
    userPath.ref.get().then((refDs) => {
      if (refDs.exists) {
        const userData = refDs.data();
        ds.providerId = userData.providerId || null;
        if (userData.providerId === 'google.com') {
          console.log(ds.providerId);
          // return this.ws.sendGglPas(ds);
          return this.ws.sendGgl(ds);
        } else if (ds.providerId?.find((pid) => pid === 'password' || pid === 'google.com')) {
          console.log(ds.providerId);
          return this.ws.sendGglPas(ds);
        } else if (userData.providerId === 'password' || ds.providerId?.find((pid) => pid === 'password')) {
          console.log(ds.providerId);
          return this.ws.sendPas(ds);
        } else if (userData.providerId === 'twitter.com' || ds.providerId?.find((pid) => pid === 'twitter.com')) {
          console.log(ds.providerId);
          return this.ws.sendTwit(ds);
        } else if (userData.providerId === 'facebook.com' || ds.providerId?.find((pid) => pid === 'facebook.com')) {
          console.log(ds.providerId);
          return this.ws.sendFac(ds);
        } else {
          console.log(ds.providerId);
        }
        this.ns.showNotification('recall', 'top', 'right', ds);
      }
    });
    // return this.ws.
  }
}
